// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__0Nawl","portalLogo":"COM001F1_portalLogo__SaeEK","infoBox":"COM001F1_infoBox__+Wc5u"};